/**
 * Cookie names.
 */
export default class LocalStorageVars {
    static SOUND_ENABLED = "SOUND_ENABLED";
    static MUSIC_ENABLED = "MUSIC_ENABLED";
    static EFFECTS_ENABLED = "EFFECTS_ENABLED";
    static MASTER_VOLUME = "MASTER_VOLUME";
    static EFFECTS_VOLUME = "EFFECTS_VOLUME";
    static MUSIC_VOLUME = "MUSIC_VOLUME";
    static LAST_BET = "LAST_BET";
    static LAST_SETTINGS_TAB = "LAST_SETTINGS_TAB";
    static AUTO_SPIN_NUMBER = "AUTO_SPIN_NUMBER";
    static STOP_ON_FREESPIN = "STOP_ON_FREESPIN";
    static STOP_ON_BONUS = "STOP_ON_BONUS";
    static QUICK_SPIN = "QUICK_SPIN";
    static LOSS_LIMIT = "LOSS_LIMIT";
    static WIN_LIMIT = "WIN_LIMIT";
    static SPIN_BUT_LAST_LANDSCAPE_X = "SPIN_BUT_LAST_LANDSCAPE_X";
    static SPIN_BUT_LAST_LANDSCAPE_Y = "SPIN_BUT_LAST_LANDSCAPE_Y";
    static SPIN_BUT_LAST_PORTRAIT_X = "SPIN_BUT_LAST_PORTRAIT_X";
    static SPIN_BUT_LAST_PORTRAIT_Y = "SPIN_BUT_LAST_PORTRAIT_Y";
    static BONUS_GAME_CURRENT_ROUND = "BONUS_GAME_CURRENT_ROUND";
    static JACKPOT_GAME_CURRENT_ROUND = "JACKPOT_GAME_CURRENT_ROUND";
    static CUSTOM_MOUSE_CURSOR_ENABLED = "CUSTOM_MOUSE_CURSOR_ENABLE";
}
